module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 2008"), _c('br'), _vm._v("\n  By Jeff Dwyer"), _c('br'), _vm._v("\n  All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('i', [_vm._v("The word “Pelican” and the depiction of a pelican are trademarks of Pelican Publishing Company, Inc., and are registered in the U.S. Patent and Trademark Office.")])]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("Dwyer, Jeff.")]), _vm._v(" "), _c('p', {
    staticClass: "copy4"
  }, [_vm._v("Ghost hunter's guide to Seattle and Puget Sound / by Jeff Dwyer."), _c('br'), _vm._v("\n  p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copy4"
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "copy5"
  }, [_vm._v("ISBN-13: 978-1-58980-517-0 (pbk. : alk. paper); 9781455604937(ebook) 1. Ghosts—Washington (State)—Seattle. 2. Haunted places—Washington (State)—Seattle. 3. Ghosts—Washington (State)—Puget Sound. 4. Haunted places—Washington (State)—Puget Sound. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copy4"
  }, [_vm._v("BF1472.U6D869 2008")]), _vm._v(" "), _c('p', {
    staticClass: "copy4"
  }, [_vm._v("133.109797'77—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copy6"
  }, [_vm._v("2008002459")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "Images/logo1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy7"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy7"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copy7"
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322269b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/03_9781589805170_Copyright.vue
// module id = 63
// module chunks = 0